import React from "react"

const about = (
  <div className="u-side-pad u-top-pad">
    <h3 className="heading--big">Follow the Journey</h3>
    <p>
      <a
        href="https://www.paekakarikihousingtrust.org/single-post/2019/04/18/Towards-marae-a-Ngati-Haumia-report"
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>
          Learn more about Ngāti Haumia, the historical owners of the land the
          hut sits upon
        </strong>
      </a>
    </p>
    <p>
      <a
        href="https://www.instagram.com/stories/highlights/18128149603008309/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>Watch moments from the build</strong>
      </a>{" "}
      (open in web browser)
    </p>
    <p>
      <a
        href="https://www.instagram.com/urbanhutclub/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>See images of others who have visited</strong>
      </a>
    </p>
    <p>
      <a
        href="https://paekakariki.nz/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>See what’s on in Paekākāriki</strong>
      </a>
    </p>

    <h3 className="heading--small">
      Share your hut selfies with us by using these tags:
    </h3>
    <p>
      INSTAGRAM:{" "}
      <a
        href="https://www.instagram.com/urbanhutclub/"
        target="_blank"
        rel="noopener noreferrer"
      >
        @UrbanHutClub
      </a>
    </p>
    <p>
      FACEBOOK:{" "}
      <a
        href="https://www.facebook.com/keminiko"
        target="_blank"
        rel="noopener noreferrer"
      >
        @keminiko
      </a>
    </p>
    <p>
      ANYWHERE:{" "}
      <a
        href="https://www.instagram.com/explore/tags/urbanhutclub/"
        target="_blank"
        rel="noopener noreferrer"
      >
        #UrbanHutClub
      </a>
    </p>

    <h3 className="heading--big">Hut credits</h3>
    <h3 className="heading--small">Designed by</h3>
    <p>Kemi Niko &amp; Co.</p>

    <h3 className="heading--small">Commissioned by</h3>
    <p>New Zealand Festival of the Arts</p>

    <h3>Partnered by</h3>
    <p>Springload</p>

    <h3 className="heading--small">Ngā mihi</h3>
    <ul className="credits__list">
      <li>Kāpiti Coast District Council</li>
      <li>Creative New Zealand</li>
      <li>New Zealand Community Trust</li>
    </ul>

    <h3>Built by</h3>
    <ul className="credits__list">
      <li>Kemi Niko &amp; Co.</li>
      <li>Olivia Rose Wiles</li>
      <li>Karl Farrell</li>
    </ul>

    <p>February 2020</p>

    <h3 className="heading--small">With Support From </h3>
    <ul className="credits__list">
      <li>Paekākāriki Community Garden and Orchards Group</li>
      <li>Mark Amery</li>
      <li>Cory Hope</li>
      <li>Josh Mountjoy</li>
      <li>Friends of Wainui Stream</li>
      <li>Paekākāriki Scouts Group</li>
      <li>Ngāti Haumia – Levi &amp; Karl</li>
      <li>Apirana Taylor</li>
    </ul>

    <h3>Materials Donated by</h3>
    <ul className="credits__list">
      <li>New Zealand Festival Workshop</li>
      <li>Mark Amery</li>
      <li>Cory Hope</li>
      <li>Paekākāriki community</li>
    </ul>
  </div>
)

export default about
